import React from 'react';
import PropTypes from 'prop-types';
import { get, map } from 'lodash';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt } from '@fortawesome/pro-solid-svg-icons';

import './styles.scss';

export default class SavedSearchList extends React.Component {
  static propTypes = {
    listFilters: PropTypes.func.isRequired,
    searches: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      query: PropTypes.object.isRequired
    })).isRequired,
    onDelete: PropTypes.func.isRequired,
    onSelect: PropTypes.func.isRequired
  };

  handleDelete = search => (e) => {
    e.stopPropagation();
    this.props.onDelete(search);
  }

  handleSelect = search => (e) => {
    e.preventDefault();
    this.props.onSelect(search);
  }

  render() {
    const { searches } = this.props;

    return (
      <ul className="list-group saved-search-list">
        {map(searches, this.renderSearch)}
      </ul>
    );
  }

  renderSearch = search => (
    <li
      className="clickable list-group-item"
      key={search.id}
      name={`search-item-${search.id}`}
      onClick={this.handleSelect(search)}
    >
      <div className="search-details text-truncate text-muted">
        <strong>{search.name}</strong>
        <div className="text-truncate">
          {this.props.listFilters(search.query, { userBounds: get(search, 'coordinates.userBounds'), limit: 3 })}
        </div>
      </div>
      <div className="search-actions">
        <span className="ps-1 float-end">
          <FontAwesomeIcon className="text-muted clickable" icon={faTrashAlt} onClick={this.handleDelete(search)} />
        </span>
      </div>
    </li>
  );
}
